import loadable from '@loadable/component';

import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const CmsRecommendedJobsBlockLoadable = hydrateOnDemand(
  loadable(() => import('./CmsRecommendedJobsBlock'), {
    resolveComponent: (module) => module.CmsRecommendedJobsBlock,
  }),
);
